/* =========================================================
   El único sitio donde la aplicación decide de dónde salen los datos.

   Para pasar de la demo local al backend real, en un archivo .env:
       VITE_DATA_SOURCE=api
       VITE_API_BASE_URL=            (vacío: la API va en el mismo origen)

   Ninguna pantalla cambia: las dos implementaciones comparten la
   misma lógica de consulta (MemoryDataSource) y el mismo contrato.
   ========================================================= */
import type { DataSource } from './DataSource';
import { MockDataSource } from './MockDataSource';
import { ApiDataSource } from './ApiDataSource';

/** ¿Está la aplicación hablando con el backend real? */
export const IS_API = import.meta.env.VITE_DATA_SOURCE === 'api';

function create(): DataSource {
  if (IS_API) return new ApiDataSource(import.meta.env.VITE_API_BASE_URL ?? '');
  return new MockDataSource();
}

export const ds: DataSource = create();

/** La fuente de datos como ApiDataSource, o null en modo demo. Lo usan
 *  el inicio de sesión (para hidratar) y la ventana de actualización. */
export const apiSource = (): ApiDataSource | null =>
  ds instanceof ApiDataSource ? ds : null;

export type { DataSource } from './DataSource';
export { MemoryDataSource } from './MemoryDataSource';
export { MockDataSource } from './MockDataSource';
export { ApiDataSource, notasDeLaUltimaPublicacion } from './ApiDataSource';
export * from './catalogs';
export { AUTH_POLICY, DEMO_USERS, userOrgIds } from './seed';
